import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from ".";
import { ItemProject, Project, ProjectWithItems } from "./db.type";

// Firebase service functions với TypeScript
export const FirebaseService = {
  // Thêm project mới
  addProject: async (projectData: Omit<Project, "id">): Promise<string> => {
    console.log("🚀 ~ projectData:", projectData);
    try {
      const docRef = await addDoc(collection(db, "projects"), projectData);
      return docRef.id;
    } catch (error) {
      console.error("Error adding project: ", error);
      throw error;
    }
  },

  // Thêm item project mới
  addItemProject: async (
    itemData: Omit<ItemProject, "id">
  ): Promise<string> => {
    try {
      const docRef = await addDoc(collection(db, "itemProjects"), itemData);
      return docRef.id;
    } catch (error) {
      console.error("Error adding item project: ", error);
      throw error;
    }
  },

  // Lấy tất cả projects
  getProjects: async (): Promise<Project[]> => {
    try {
      const snapshot = await getDocs(collection(db, "projects"));
      console.log(
        "🚀 ~ snapshot:",
        snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
      return snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as Project[];
    } catch (error) {
      console.error("Error getting projects: ", error);
      throw error;
    }
  },

  // Lấy items theo projectId
  getItemsByProjectId: async (projectId: string): Promise<ItemProject[]> => {
    try {
      const itemsRef = collection(db, "itemProjects");
      const q = query(itemsRef, where("projectId", "==", projectId));
      const snapshot = await getDocs(q);
      return snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as ItemProject[];
    } catch (error) {
      console.error("Error getting items: ", error);
      throw error;
    }
  },

  // Lấy chi tiết project kèm items
  getProjectWithItems: async (
    projectId: string
  ): Promise<ProjectWithItems | null> => {
    try {
      const [projects, items] = await Promise.all([
        FirebaseService.getProjects(),
        FirebaseService.getItemsByProjectId(projectId),
      ]);

      const project = projects.find((p) => p.id === projectId);
      if (!project) return null;

      return {
        ...project,
        items,
      };
    } catch (error) {
      console.error("Error getting project with items: ", error);
      throw error;
    }
  },

  deleteProject: async (projectId: string): Promise<Project[]> => {
    try {
      await deleteDoc(doc(db, "projects", projectId));

      const itemsRef = collection(db, "itemProjects");
      const q = query(itemsRef, where("projectId", "==", projectId));
      const snapshot = await getDocs(q);
      const listItem = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as ItemProject[];

      listItem.forEach(async (item) => {
        await deleteDoc(doc(db, "itemProjects", item.id));
      });

      return await FirebaseService.getProjects();
    } catch (error) {
      console.error("Error deleting project: ", error);
      throw error;
    }
  },
};
